export enum Languages {
	UA = 'UA', 
	RU = 'RU'
};